export default (projectID, type = '') => {
  window.open(`/printcomments?projectID=${projectID}&type=${type}`, '_blank');
};
